/* thalea theme — cart drawer, variant picker, nav drawer */

(function () {
  'use strict';

  const FREE_SHIP_THRESHOLD = 25000; // AED 250 in fils (Shopify uses smallest currency unit)

  /* ─── Helpers ─── */
  function money(cents) {
    return 'AED ' + (cents / 100).toFixed(0);
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }

  /* ─── Cart Drawer ─── */
  const cartOverlay = qs('.cart-overlay');
  const cartDrawer  = qs('.cart-drawer');

  function openCart() {
    if (!cartDrawer) return;
    fetchCart();
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Fetch Shopify cart and re-render drawer */
  function fetchCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => renderCart(cart))
      .catch(console.error);
  }

  function renderCart(cart) {
    const itemsEl   = qs('.cart-items');
    const countEls  = qsa('[data-cart-count]');
    const totalEls  = qsa('[data-cart-total]');
    const titleEl   = qs('.cart-drawer__title');
    const fillEl    = qs('.cart-shipping-bar__fill');
    const shipLabel = qs('.cart-shipping-bar__label');
    const checkoutBtn = qs('[data-checkout-btn]');

    /* count badge */
    const itemCount = cart.item_count || 0;
    countEls.forEach(el => { el.textContent = itemCount; el.style.display = itemCount ? '' : 'none'; });
    if (titleEl) titleEl.innerHTML = `your bag <span class="cart-drawer__count">(${itemCount})</span>`;

    /* total */
    const subtotal = cart.total_price || 0;
    totalEls.forEach(el => { el.textContent = money(subtotal); });
    if (checkoutBtn) checkoutBtn.textContent = `checkout · ${money(subtotal)}`;

    /* free shipping bar */
    if (fillEl) {
      const pct = Math.min((subtotal / FREE_SHIP_THRESHOLD) * 100, 100);
      fillEl.style.width = pct + '%';
    }
    if (shipLabel) {
      if (subtotal >= FREE_SHIP_THRESHOLD) {
        shipLabel.textContent = "you've unlocked free shipping ✓";
      } else {
        const remaining = money(FREE_SHIP_THRESHOLD - subtotal);
        shipLabel.textContent = `spend ${remaining} more for free shipping`;
      }
    }

    /* line items */
    if (!itemsEl) return;
    itemsEl.innerHTML = '';
    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<p style="padding:40px 0;text-align:center;font-family:var(--mono);font-size:12px;letter-spacing:.2em;text-transform:uppercase;opacity:.6">your bag is empty</p>';
      return;
    }
    cart.items.forEach(item => {
      const img  = item.featured_image ? item.featured_image.url : '';
      const imgTag = img ? `<img class="cart-item__img" src="${img}" alt="${item.title}" loading="lazy">` : '';
      const div  = document.createElement('div');
      div.className = 'cart-item';
      div.dataset.key = item.key;
      div.innerHTML = `
        <div class="cart-item__img-wrap">${imgTag}</div>
        <div class="cart-item__info">
          <div class="cart-item__name">${item.product_title}</div>
          <div class="cart-item__variant mono">${item.variant_title || ''}</div>
          <div class="cart-item__bottom">
            <div class="cart-qty-stepper" data-key="${item.key}">
              <button class="cart-qty-btn" data-action="decrease" aria-label="decrease">−</button>
              <span class="cart-qty-val">${item.quantity}</span>
              <button class="cart-qty-btn" data-action="increase" aria-label="increase">+</button>
            </div>
            <span class="cart-item__price">${money(item.line_price)}</span>
          </div>
        </div>`;
      itemsEl.appendChild(div);
    });

    /* stepper events */
    itemsEl.querySelectorAll('.cart-qty-stepper').forEach(stepper => {
      stepper.addEventListener('click', e => {
        const btn = e.target.closest('.cart-qty-btn');
        if (!btn) return;
        const key = stepper.dataset.key;
        const valEl = stepper.querySelector('.cart-qty-val');
        let qty = parseInt(valEl.textContent, 10);
        if (btn.dataset.action === 'increase') qty++;
        else qty = Math.max(0, qty - 1);
        updateCartItem(key, qty);
      });
    });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    })
      .then(r => r.json())
      .then(cart => renderCart(cart))
      .catch(console.error);
  }

  /* ─── Add to Cart ─── */
  function addToCart(variantId, quantity, callback) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
    })
      .then(r => r.json())
      .then(() => { if (callback) callback(); openCart(); })
      .catch(err => { console.error(err); });
  }

  /* ─── Event wiring ─── */
  document.addEventListener('DOMContentLoaded', () => {
    /* overlay / close button */
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
    const closeBtn = qs('.cart-drawer__close');
    if (closeBtn) closeBtn.addEventListener('click', closeCart);

    /* bag icon in nav */
    qsa('[data-open-cart]').forEach(el => el.addEventListener('click', openCart));

    /* continue shopping link */
    const continueShopping = qs('[data-continue-shopping]');
    if (continueShopping) continueShopping.addEventListener('click', e => { e.preventDefault(); closeCart(); });

    /* initial cart count */
    fetchCart();

    /* ── PDP form ── */
    const pdpForm = qs('.pdp-form');
    if (pdpForm) initPDP(pdpForm);

    /* ── Product card quick-add ── */
    qsa('.js-quick-add').forEach(btn => {
      btn.addEventListener('click', e => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        if (!variantId) return;
        addToCart(variantId, 1);
      });
    });

    /* ── Nav drawer (mobile) ── */
    const hamburger  = qs('.nav__hamburger');
    const navDrawer  = qs('.nav-drawer');
    const navClose   = qs('.nav-drawer__close');
    if (hamburger && navDrawer) {
      hamburger.addEventListener('click', () => navDrawer.classList.add('is-open'));
      if (navClose) navClose.addEventListener('click', () => navDrawer.classList.remove('is-open'));
    }

    /* ── Collection filter pills ── */
    qsa('.filter-pill[data-filter]').forEach(pill => {
      pill.addEventListener('click', () => {
        qsa('.filter-pill').forEach(p => p.classList.remove('filter-pill--active'));
        pill.classList.add('filter-pill--active');
        const filter = pill.dataset.filter;
        qsa('.product-card[data-type]').forEach(card => {
          card.style.display = (filter === 'all' || card.dataset.type === filter) ? '' : 'none';
        });
      });
    });

    /* ── PDP gallery thumb switching ── */
    qsa('.pdp-thumb').forEach((thumb, i) => {
      thumb.addEventListener('click', () => {
        qsa('.pdp-thumb').forEach(t => t.classList.remove('pdp-thumb--active'));
        thumb.classList.add('pdp-thumb--active');
        const mainImg = qs('.pdp-main-img');
        if (mainImg) mainImg.src = thumb.dataset.imgSrc || mainImg.src;
      });
    });
  });

  /* ─── PDP initialiser ─── */
  function initPDP(form) {
    const variantInput  = form.querySelector('[name="id"]');
    const addBtn        = form.querySelector('.js-atb');
    const priceEl       = form.querySelector('[data-pdp-price]');
    const variantsScript = form.querySelector('.js-variants-data');
    if (variantsScript) {
      try { form.dataset.variants = variantsScript.textContent; } catch(e) {}
    }

    /* colour swatches */
    qsa('.pdp-swatch').forEach(sw => {
      sw.addEventListener('click', () => {
        qsa('.pdp-swatch').forEach(s => s.classList.remove('pdp-swatch--active'));
        sw.classList.add('pdp-swatch--active');
        syncVariant(form);
      });
    });

    /* size tiles */
    qsa('.pdp-size-tile').forEach(tile => {
      if (tile.classList.contains('pdp-size-tile--unavailable')) return;
      tile.addEventListener('click', () => {
        qsa('.pdp-size-tile').forEach(t => t.classList.remove('pdp-size-tile--active'));
        tile.classList.add('pdp-size-tile--active');
        syncVariant(form);
      });
    });

    /* add to bag */
    if (addBtn) {
      addBtn.addEventListener('click', e => {
        e.preventDefault();
        const selectedSize = qs('.pdp-size-tile--active');
        if (!selectedSize) {
          addBtn.textContent = 'please select a size';
          setTimeout(() => {
            addBtn.textContent = addBtn.dataset.defaultText || 'add to bag';
          }, 1800);
          return;
        }
        const vid = variantInput ? variantInput.value : '';
        if (!vid) return;
        addBtn.textContent = 'adding…';
        addToCart(vid, 1, () => {
          addBtn.textContent = 'added ✓';
          setTimeout(() => { addBtn.textContent = addBtn.dataset.defaultText || 'add to bag'; }, 2000);
        });
      });
    }
  }

  /* Match selected colour + size to a variant; update price + variantId */
  function syncVariant(form) {
    const variantData = JSON.parse(form.dataset.variants || '[]');
    const colourEl    = qs('.pdp-swatch--active', form.closest('.pdp-info') || document);
    const sizeEl      = qs('.pdp-size-tile--active', form.closest('.pdp-info') || document);

    const colour = colourEl ? colourEl.dataset.value : null;
    const size   = sizeEl   ? sizeEl.dataset.value   : null;

    const match = variantData.find(v => {
      const opts = v.options || [];
      const colourMatch = !colour || opts.includes(colour) || v.option1 === colour || v.option2 === colour;
      const sizeMatch   = !size   || opts.includes(size)   || v.option1 === size   || v.option2 === size;
      return colourMatch && sizeMatch;
    });

    const variantInput = form.querySelector('[name="id"]');
    const priceEl      = form.querySelector('[data-pdp-price]');
    const addBtn       = form.querySelector('.js-atb');

    if (match) {
      if (variantInput) variantInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (addBtn) {
        const label = addBtn.dataset.defaultText || 'add to bag';
        addBtn.textContent = `${label} · ${money(match.price)}`;
        addBtn.disabled = !match.available;
        addBtn.classList.toggle('btn--outline', !match.available);
      }
    }
  }

  /* expose for inline use */
  window.thaleaCart = { open: openCart, close: closeCart, add: addToCart };
})();
